<template>
  <line-block :value="value" :mode="mode" :state.sync="state">
    <template v-slot:control-handlers>
      <ShapeControlHandle
        v-if="isVisibleShapeControlHandle"
        class="shape-line-connector-handler-x"
        :x="s"
        :x-range="[0, w]"
        :y="h / 2"
        :angle="value.rotation"
        @update:x="x => (value.data.controls.slope = x / w)" />
    </template>
    <template v-slot:main>
      <svg
        class="shape-line-connector"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        style="overflow: visible; z-index: 999; vertical-align: top"
        :width="w"
        :height="h"
        preserveAspectRatio="none"
        :viewBox="`0 0 ${w} ${h}`">
        <defs>
          <component
            v-if="MarkerBegin"
            :id="`markerBegin-connector-${id}`"
            :is="MarkerBegin.component"
            :stroke="stroke"
            :markerSize="value.data.begin.marker.size"
            orient="auto-start-reverse" />
          <component
            v-if="MarkerEnd"
            :id="`markerEnd-connector-${id}`"
            :is="MarkerEnd.component"
            :stroke="stroke"
            :markerSize="value.data.end.marker.size"
            orient="auto" />
        </defs>

        <path
          :d="`
            M ${end.x > begin.x ? 0 : w} ${end.y > begin.y ? 0 : h} 
            L ${w * value.data.controls.slope} ${end.y > begin.y ? 0 : h}
            L ${w * value.data.controls.slope} ${end.y > begin.y ? h : 0} 
            L ${end.x > begin.x ? w : 0} ${end.y > begin.y ? h : 0}
          `"
          :style="{
            fill: value.data.style.fill,
            stroke: value.data.style.stroke,
            strokeWidth: value.data.style.strokeWidth,
            strokeDasharray: lineStyle,
            strokeLinecap: lineCap
          }" />
        <path
          :d="`M 
            ${end.x > begin.x ? 0 : w} 
            ${end.y > begin.y ? 0 : h} 
            ${end.x > begin.x ? w : 0} 
            ${end.y > begin.y ? h : 0}
          `"
          :style="{
            strokeWidth: value.data.style.strokeWidth,
            markerStart: `url(#markerBegin-connector-${id})`,
            markerEnd: `url(#markerEnd-connector-${id})`,
            strokeDasharray: lineStyle,
            strokeLinecap: lineCap
          }" />
      </svg>
    </template>
  </line-block>
</template>

<script>
import LineBlock from "../_components/containers/LineBlock.vue"
import ShapeControlHandle from "../_components/utils/ShapeControlHandle.vue"
import { BlockSelectionState } from "../_models/blockSelectionState";
import Markers from "./markers/Markers.js"

export default {
  name: "BlockShapeLineConnector",
  components: {
    LineBlock,
    ShapeControlHandle
  },
  props: ["value", "mode"],
  data() {
    return {
      state: BlockSelectionState.notSelected
    }
  },
  created() {
    if(!this.value.data.style.lineStyle) {
      this.$set(this.value.data.style, "lineStyle", "solid");
    } 
    if(!this.value.data.style.pointsSize) {
      this.$set(this.value.data.style, "pointsSize", 2);
    } 
    if(!this.value.data.style.spacesSize) {
      this.$set(this.value.data.style, "spacesSize", 2);
    }
  },
  computed: {
    isVisibleShapeControlHandle() {
      return this.state === BlockSelectionState.primarySelected && this.mode === "edit";
    },
    s() {
      return this.value.size.width * this.value.data.controls.slope
    },
    id() {
      return this.value.id
    },
    length() {
      return Math.sqrt(this.w * this.w + this.h * this.h)
    },
    w() {
      return this.value.size.width
    },
    h() {
      return this.value.size.height
    },
    deltaBeginX() {
      if (!this.MarkerBegin) return 0
      var { delta } = this.MarkerBegin
      return (delta * this.strokeWidth * this.beginSize * this.w) / this.length
    },
    deltaBeginY() {
      if (!this.MarkerBegin) return 0
      var { delta } = this.MarkerBegin
      return (delta * this.strokeWidth * this.beginSize * this.h) / this.length
    },
    deltaEndX() {
      if (!this.MarkerEnd) return 0
      var { delta } = this.MarkerEnd
      return (delta * this.strokeWidth * this.endSize * this.w) / this.length
    },
    deltaEndY() {
      if (!this.MarkerEnd) return 0
      var { delta } = this.MarkerEnd
      return (delta * this.strokeWidth * this.endSize * this.h) / this.length
    },

    begin() {
      return this.value.data.begin
    },
    beginSize() {
      return this.value.data.begin.marker.size
    },
    end() {
      return this.value.data.end
    },
    endSize() {
      return this.value.data.end.marker.size
    },
    stroke() {
      return this.value.data.style.stroke
    },
    strokeWidth() {
      return this.value.data.style.strokeWidth
    },
    MarkerBegin() {
      var selectedMarker = Markers.find(marker => marker.value == this.value.data.begin.marker.type)
      if (selectedMarker) {
        return selectedMarker
      } else {
        return false
      }
    },
    MarkerEnd() {
      var selectedMarker = Markers.find(marker => marker.value == this.value.data.end.marker.type)
      if (selectedMarker) {
        return selectedMarker
      } else {
        return false
      }
    },
    lineStyle() {
      switch(this.value.data.style.lineStyle) {
        case 'dashed':
          return `${this.strokeWidth * this.value.data.style.pointsSize}, ${this.strokeWidth * this.value.data.style.spacesSize}`
        case 'dotted':
          return `0, ${this.strokeWidth * this.value.data.style.spacesSize}`
        default:
          return null
      }
    },
    lineCap() {
      return this.value.data.style.lineStyle === "dotted" ? "round" : null;
    }
  }
}
</script>
